import {
  CLEAR_ADMIN_AUDIT_SEARCH,
  SELECT_ADMIN_AUDIT_TAB,

  ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL,
  ADMIN_AUDIT_TAB_CAPTAINS_LABEL,
  ADMIN_AUDIT_TAB_TEAMS_LABEL,
  ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL,
  ADMIN_AUDIT_TAB_BOWLERS_LABEL
} from './constants';

export const initialState = { 
  auditActions: [{
      active: true,
      label: ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL,
      to: "admin/audit"
    }, {
      active: false,
      label: ADMIN_AUDIT_TAB_CAPTAINS_LABEL,
      to: "admin/audit"
    }, {
      active: false,
      label: ADMIN_AUDIT_TAB_TEAMS_LABEL,
      to: "admin/audit"
    }, {
      active: false,
      label: ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL,
      to: "admin/audit"
    }, {
      active: false,
      label: ADMIN_AUDIT_TAB_BOWLERS_LABEL,
      to: "admin/audit"
    }]
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case CLEAR_ADMIN_AUDIT_SEARCH:
      return {
        ...initialState
      }; 

    case SELECT_ADMIN_AUDIT_TAB:
      state.auditActions.forEach(a => a.active = (a.label == payload.label));
      return {
        ...state
      }; 
      
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/admin/audit/reducer.js